export default __webpack_public_path__ + "static/media/ODEImg4.254bfaf8.PNG";